module.exports = __webpack_public_path__ + "static/westfield_white-4162a22eb528f0a95cb03c9e56b534a1.png";